import React from 'react';
import PropTypes from 'prop-types';
import { styled, Tooltip, tooltipClasses } from '@mui/material';

import './styles.scss';

const SEVERITY_COLOR = {
  low: '#5764F5',
  medium: '#FFD88C',
  high: '#FF771D',
  critical: '#C0383D',
};

const MARKER_SIZE = {
  xs: '8',
  sm: '16',
  md: '24',
  lg: '32',
};

const TooltipWrapper = styled(({ className, ...props }) => <Tooltip {...props} classes={{ popper: className }} />)(
  () => ({
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: '#FFF',
      color: '#000',
      fontSize: 14,
      fontWeight: 'bold',
      borderRadius: '6px',
      boxShadow: '0 .2rem .8rem rgba(7,9,25,.18), 0 .08rem .15rem rgba(7,9,25,.15)',
    },
    [`& .${tooltipClasses.arrow}`]: {
      color: '#FFF',
    },
  }),
);

// Styled circle element
const AnimCircle = styled('circle')(
  ({ theme, 'data-size': size, 'data-color': color }) => `
    r: ${size / 2 - 2};
    fill: ${color};
    animation: ripple 1s infinite;
    transition: ${theme.transitions.create('all')};
  `,
);

const ThreatGeoMarker = ({ severity, size = 'md', country }) => (
  <>
    <circle r={MARKER_SIZE[size] / 2 - 1} fill={SEVERITY_COLOR[severity]} />
    <TooltipWrapper placement="top" arrow title={country}>
      <AnimCircle data-size={MARKER_SIZE[size]} data-color={SEVERITY_COLOR[severity]} />
    </TooltipWrapper>
  </>
);

ThreatGeoMarker.propTypes = {
  severity: PropTypes.oneOf(['low', 'medium', 'high', 'critical']),
  size: PropTypes.oneOf(['xs', 'sm', 'md', 'lg']),
  country: PropTypes.string,
};

export default ThreatGeoMarker;
